export default __webpack_public_path__ + "img/655d85b83fb58cd92b00ffa306993cbd.png";